export default __webpack_public_path__ + "assets/images/h-phone-icon-9c691c0b.svg";